import * as tslib_1 from "tslib";
import { Data } from '../data';
import { ToolBar } from '../../commands/index';
import { ToolHelper } from '../../utility/index';
var Paginition = /** @class */ (function () {
    function Paginition(param) {
        var _this = this;
        var obj;
        if (typeof param === 'string') {
            obj = JSON.parse(param);
        }
        else {
            obj = param;
        }
        if (!obj) {
            return;
        }
        var keys = 'pageSize,pageNumber';
        Object.keys(obj).forEach(function (key) {
            if (keys.includes(key)) {
                _this[key] = obj[key];
            }
        });
    }
    Paginition.prototype.toJSON = function () {
        return {
            "type": "Paginition",
            "pageSize": this.pageSize,
            "pageNumber": this.pageNumber
        };
    };
    Paginition.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return Paginition;
}());
export { Paginition };
var SummaryItem = /** @class */ (function () {
    function SummaryItem(param) {
        var _this = this;
        var obj;
        if (typeof param === 'string') {
            obj = JSON.parse(param);
        }
        else {
            obj = param;
        }
        if (!obj) {
            return;
        }
        var keys = 'summaryType,aggregationType,name,column,align,format,customizeText,showInGroupFooter,skipEmptyValues';
        Object.keys(obj).forEach(function (key) {
            if (keys.includes(key)) {
                _this[key] = obj[key];
            }
        });
    }
    SummaryItem.prototype.toJSON = function () {
        return {
            "summaryType": this.summaryType,
            "aggregationType": this.aggregationType,
            "name": this.summaryType,
            "column": this.summaryType,
            "align": this.summaryType,
            "format": this.summaryType,
            "customizeText": this.customizeText,
            "showInGroupFooter": this.showInGroupFooter,
            "skipEmptyValues": this.skipEmptyValues,
        };
    };
    SummaryItem.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return SummaryItem;
}());
export { SummaryItem };
var Summary = /** @class */ (function () {
    function Summary(param) {
        var _this = this;
        var obj;
        if (typeof param === 'string') {
            obj = JSON.parse(param);
        }
        else {
            obj = param;
        }
        if (!obj) {
            return;
        }
        this.items = [];
        var keys = 'items';
        Object.keys(obj).forEach(function (key) {
            if (keys.includes(key)) {
                obj[key].forEach(function (item) {
                    _this.items.push(new SummaryItem(item));
                });
            }
        });
    }
    Summary.prototype.toJSON = function () {
        var itemArray = [];
        if (this.items && this.items.length) {
            this.items.forEach(function (item) {
                itemArray.push(item.toJSON());
            });
        }
        return Object.assign({}, {
            "items": itemArray
        });
    };
    Summary.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return Summary;
}());
export { Summary };
var DataCollection = /** @class */ (function (_super) {
    tslib_1.__extends(DataCollection, _super);
    function DataCollection(param) {
        var _this = _super.call(this, param) || this;
        var obj;
        if (typeof param === 'string') {
            obj = JSON.parse(param);
        }
        else {
            obj = param;
        }
        if (!obj) {
            return _this;
        }
        _this.fields = [];
        var keys = "dataSource,fields,focusedItem,focusedIndex,pagination,identifyField,multiSelect\n    ,selectable,itemTemplate,toolBar,sortable,sort,summary";
        Object.keys(obj).forEach(function (key) {
            if (keys.includes(key)) {
                switch (key) {
                    case 'fields':
                        obj[key].forEach(function (item) {
                            var domObj = ToolHelper.createObjectByType(item.type);
                            if (domObj) {
                                _this.fields.push(new domObj(item));
                            }
                        });
                        break;
                    case 'pagination':
                        _this[key] = new Paginition(obj[key]);
                        break;
                    case 'toolBar':
                        _this[key] = new ToolBar(obj[key]);
                        break;
                    case 'summary':
                        _this[key] = new Summary(obj[key]);
                        break;
                    default:
                        _this[key] = obj[key];
                        break;
                }
            }
        });
        return _this;
    }
    DataCollection.prototype.toJSON = function () {
        var _this = this;
        var fieldArray = [];
        if (this.fields && this.fields.length) {
            this.fields.forEach(function (f) {
                fieldArray.push(f.toJSON());
            });
        }
        var result = {
            "type": "DataCollection",
            "dataSource": this.dataSource,
            "fields": fieldArray,
            "focusedItem": this.focusedItem,
            "focusedIndex": this.focusedIndex,
            "pagination": null,
            "identifyField": this.identifyField,
            "multiSelect": this.multiSelect,
            "selectable": this.selectable,
            "itemTemplate": this.itemTemplate,
            "toolBar": null,
            "sortable": this.sortable,
            "sort": this.sort,
            "summary": null
        };
        var keys = 'pagination,toolBar,summary';
        keys.split(',').forEach(function (key) {
            if (_this[key]) {
                result[key] = _this[key].toJSON();
            }
        });
        return Object.assign({}, _super.prototype.toJSON.call(this), result);
    };
    DataCollection.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return DataCollection;
}(Data));
export { DataCollection };
//# sourceMappingURL=data_collection.js.map